const pendingInvitationKey = "safeplate.pending-invitation";

function validToken(value: string): string | null {
  const token = value.trim();
  return /^[A-Za-z0-9_-]{16,512}$/.test(token) ? token : null;
}

export function invitationTokenFromInput(input: string): string | null {
  const direct = validToken(input);
  if (direct) return direct;

  try {
    const url = new URL(input.trim());
    const queryToken = url.searchParams.get("token");
    if (queryToken) return validToken(queryToken);

    const segments = url.pathname.split("/").filter(Boolean);
    let marker = -1;
    for (let index = segments.length - 1; index >= 0; index -= 1) {
      if (segments[index] === "invite" || segments[index] === "accept") {
        marker = index;
        break;
      }
    }
    return marker >= 0 ? validToken(segments[marker + 1] ?? "") : null;
  } catch {
    return null;
  }
}

export function rememberInvitationToken(token: string): void {
  globalThis.sessionStorage?.setItem(pendingInvitationKey, token);
}

export function pendingInvitationToken(): string | null {
  return globalThis.sessionStorage?.getItem(pendingInvitationKey) ?? null;
}

export function clearPendingInvitationToken(): void {
  globalThis.sessionStorage?.removeItem(pendingInvitationKey);
}
